require('./stylesheets/_registration.scss');

angular.module('pages.passwordRecovery', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.password-recovery', {
			url: 'password-recovery',
			template: require('./templates/index.html'),
			controller: require('./controllers/passwordRecovery.controller'),
			params: {
				title: null,
				back:null,
				hided:true
			},
			data:{
				iframe: false
			},
			pageTrack: '/passwordRecovery'
		})
}

module.exports = 'pages.passwordRecovery';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/passwordRecovery/index.js
 ** module id = 280
 ** module chunks = 1
 **/